import argosPageTitles from './pageTitles/argosPageTitles'
import argosPageHeadings from './headings/argosPageHeadings'
import tuPageHeadings from './headings/tuPageHeadings'
import { getBrand } from '../../utils/ConfigProvider'

const trimRefinementSlashes = refinement => {
  return refinement
    ?.replace(/^\//, '') // Remove leading slash
    ?.replace(/\/$/, '') // Remove trailing slash
}

export const getOverridenPageTitle = (urlCategoryId, urlRefinements) => {
  if (!urlCategoryId) {
    return null
  }
  const cleanUrlRefinements = trimRefinementSlashes(urlRefinements)

  return argosPageTitles?.[urlCategoryId]?.[cleanUrlRefinements] || null
}

// Match specific categories and refinements to custom set titles
export const getOverridenPageHeading = (urlCategoryId, urlRefinements) => {
  if (!urlCategoryId) {
    return null
  }
  const brand = getBrand()
  const cleanUrlRefinement = trimRefinementSlashes(urlRefinements)

  let customRefinedHeading
  switch (brand) {
    case 'argos':
      customRefinedHeading = argosPageHeadings?.[urlCategoryId]?.[cleanUrlRefinement]
      break
    case 'tu':
      customRefinedHeading = tuPageHeadings?.[urlCategoryId]?.[cleanUrlRefinement]
      break
    default:
      customRefinedHeading = null
  }

  return customRefinedHeading || null
}
